// src/components/WebsiteExperimentEntry.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Card, Spinner, Alert } from 'react-bootstrap';
import useToken from '../../hooks/useToken';
import useProgressRedirect from '../../hooks/useProgressRedirect'; // 🆕 Import useProgressRedirect
import ProgressTracker from '../shared/ProgressTracker';

function WebsiteExperimentEntry() {
  const { token, refreshAccessToken } = useToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useProgressRedirect("EXPERIMENT"); // <=== Auto redirect if necessary!

  const handleStartExperiment = async () => {
    setLoading(true);
    setError('');

    try {
      const authToken = token || await refreshAccessToken();

      // Step 2: Fetch assignment
      const assignmentRes = await fetch("/api"+'/assignment', {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      const assignmentData = await assignmentRes.json();

      if (!Array.isArray(assignmentData) || assignmentData.length === 0) {
        throw new Error('No assignments found');
      }

      // Step 3: Update progress and redirect to Documentation Review
      const progressRes = await fetch("/api"+'/player/progress', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ progress_step: 'DOCUMENTATION_REVIEW' }),
      });

      if (progressRes.ok) {
        navigate('/documentation-review', { replace: true }); // ✅ If success, move to documentation review
      } else {
        console.error('Failed to update progress');
      }
    } catch (err) {
      console.error(err);
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <ProgressTracker currentStep="platform_tutorial" />
      <Card className="shadow p-4">
        <h2 className="mb-4">🧪 Ready to Begin the Experiment?</h2>
        <p>
          You are about to begin the practical part of the penetration testing study. 
          After clicking the button below, your assignments will be prepared and 
          you will be redirected to your first target application.
        </p>

        {error && <Alert variant="danger">{error}</Alert>}

        <div className="d-grid">
          <Button variant="success" onClick={handleStartExperiment} disabled={loading}>
            {loading ? <><Spinner size="sm" animation="border" className="me-2" /> Preparing Environment...</> : '🚀 Start the Experiment'}
          </Button>
        </div>
      </Card>
    </Container>
  );
}

export default WebsiteExperimentEntry;
